<template>
    <div class="template-detail-tabs">
        <div class="tab-header">
            <button
                v-for="(tab, index) in tabs"
                :key="index"
                :class="['tab-btn', { active: currentTab === tab.key }]"
                @click="$emit('tab-change', tab.key)"
            >
                {{ tab.label }}
            </button>
        </div>

        <div class="tab-content">
            <slot :currentTab="currentTab">
                <!-- 기본 플레이스홀더 -->
                <div class="tab-placeholder">
                    <div class="placeholder-content">
                        <div class="placeholder-label">{{ currentTabLabel }} 탭 내용</div>
                        <div class="placeholder-text">탭 내용을 여기에 표시합니다</div>
                    </div>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "TemplateDetailTabs",
    props: {
        tabs: {
            type: Array,
            default: () => [
                { key: "tab1", label: "탭 1" },
                { key: "tab2", label: "탭 2" },
                { key: "tab3", label: "탭 3" },
            ],
        },
        currentTab: {
            type: String,
            default: "tab1",
        },
    },
    computed: {
        currentTabLabel() {
            const tab = this.tabs.find((t) => t.key === this.currentTab);
            return tab ? tab.label : "탭";
        },
    },
};
</script>

<style scoped>
.template-detail-tabs {
    background: white;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e2e8f0;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.tab-header {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
}

.tab-btn {
    padding: 8px 16px;
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
}

.tab-btn:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    color: #1e293b;
}

.tab-btn.active {
    background: #64748b;
    border-color: #64748b;
    color: white;
    box-shadow: 0 2px 4px rgba(100, 116, 139, 0.2);
}

.tab-btn:focus {
    outline: none;
}

.tab-content {
    flex: 1;
    min-height: 300px;
    overflow-y: auto;
}

.tab-placeholder {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.placeholder-content {
    text-align: center;
}

.placeholder-label {
    font-size: 16px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
}

.placeholder-text {
    font-size: 13px;
    color: #94a3b8;
}

.tab-content::-webkit-scrollbar {
    width: 6px;
}

.tab-content::-webkit-scrollbar-track {
    background: transparent;
}

.tab-content::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
}

.tab-content::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}
</style>
